import * as type from './types';

export const restaurantSearchByName = /* GraphQL */ `
  query RestaurantSearchByName($name: String!) {
    restaurantSearchByName(name: $name) {
      ${type.Restaurant}
    }
  }
`;

export const linkedVenues = /* GraphQL */ `
  query ObeeUserLinkedVenues($restId: String!, $ssoToken: String) {
    obeeUserLinkedVenues(restId: $restId, ssoToken: $ssoToken)
  }
`;

export const restaurantBySlug = /* GraphQL */ `
  query RestaurantBySlug($slug: String!) {
    restaurantBySlug(slug: $slug) {
      ${type.RestaurantForSwitcher}
    }
  }
`;

export const ssoCreds = /* GraphQL */ `
  query SsoCreds($ssoToken: String!) {
    ssoCreds(ssoToken: $ssoToken)
  }
`;

export const staffById = /* GraphQL */ `
  query StaffById($staffId: String!) {
    staffById(staffId: $staffId) {
      email
      name
      objectId
    }
  }
`;

export const userById = /* GraphQL */ `
  query UserById($userId: String!) {
    userById(userId: $userId) {
      email
      name
      objectId
      restaurants
    }
  }
`;

export const restaurantById = /* GraphQL */ `
  query RestaurantById($restId: String!) {
    restaurantById(restId: $restId) {
      ${type.Restaurant}
    }
  }
`;

export const obeeSso = /* GraphQL */ `
  query ObeeSSO($ssoToken: String!) {
    obeeSSO(ssoToken: $ssoToken)
  }
`;

export const obeeSettings = /* GraphQL */ `
  query ObeeSettings($restId: String!) {
    obeeSettings(restId: $restId) {
      defaultLandingPage
    }
  }
`;
